export enum PERMISSION {
  accessCart = 'access_cart',
  editCxmlCart = 'edit_cxml_cart',
  accessCheckout = 'access_checkout',
  accessCheckoutCollectOrder = 'access_checkout_collect_order',
  accessMyAccountAddresses = 'access_my_account_addresses',
  accessMyAccountBasic = 'access_my_account_basic',
  accessMyAccountDashboard = 'access_my_account_dashboard',
  accessMyAccountNewsletters = 'access_my_account_newsletters',
  accessMyAccountRma = 'access_my_account_rma',
  accessMyAccountUserContactInformationChange = 'access_my_account_edit_contact_information',
  accessMyAccountUserBillingAddressChange = 'access_my_account_billing_address_change',
  accessMyAccountUserManagement = 'access_my_account_user_management',
  accessMyAccountUserRole = 'access_my_account_user_role',
  myAccountDeleteUser = 'my_account_delete_user',
  myAccountEditUser = 'my_account_edit_user',
  accessWishlist = 'access_wishlist',
  oci = 'oci',
  cxml = 'cxml',
  productPdfExport = 'pdf_export',
  seeUserPrice = 'see_user_price',
  accessKanban = 'access_kanban'
}

export const hasPermissions = (permissionsRequired: string[], permissionsGiven: string[]): boolean => {
  if (!Array.isArray(permissionsRequired) || !permissionsRequired.length) {
    return true;
  }

  if (!Array.isArray(permissionsGiven)) {
    permissionsGiven = [];
  }

  for (const permission of permissionsRequired) {
    if (!permissionsGiven.includes(permission)) {
      return false;
    }
  }

  return true;
};
